<template>
    <ul class="list-inline" v-if="components && components.length > 0">
        <li class="list-inline-item mr-4" v-for="component in components">
            <div class="mx-auto text-center">
                <i :class="component.icon_class"></i>
                <br v-if="showBr">
                {{ component.name }}
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: "RaceComponents",
    props: {
        components: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        showBr() {
            return this.components.length > 1;
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Utility/RaceComponents.vue